const a = {
  width: 450,
  height: 750,
  lockRatio: !1
};
function e() {
  return {
    theme: "light",
    tokens: {},
    partOverrides: [],
    rawCss: ""
  };
}
function t() {
  return {
    modality: "floating"
  };
}
function n() {
  return {
    customerLogoUrl: ""
  };
}
function i() {
  return {
    design: e(),
    shell: t(),
    branding: n()
  };
}
const r = [
  "floating",
  "fullpage"
];
export {
  a as D,
  r as M,
  e as a,
  t as b,
  n as c,
  i as d
};
//# sourceMappingURL=modality-C-oMH_zm.js.map
